/* eslint-disable import/no-relative-packages */

import { sprintf } from '../../vendor/sprintf-js';
import { country } from '../localization';

const fmtHours = (h) => ((h > 1) ? `${h} hours` : `${h} hour`);
const fmtMins = (m) => ((m > 1) ? `${m} mins` : `${m} min`);
// const fmtSeconds = (s) => ((s > 1) ? `${s} seconds` : `${s} second`);

// const fmtKilometers = (km) => ((km > 1) ? `${km} kilometers` : '1 kilometer');
const fmtMeters = (m) => ((m > 1) ? `${m} meters` : '1 meter');
const fmtFeet = (m) => ((m > 1) ? `${m} feet` : '1 foot');

export const enTime = (duration) => {
  let durationText;

  const h = Math.round(duration / 3600);
  const m = Math.round(duration / 60) % 60;
  // const s = duration % 60;
  if (h > 0) {
    durationText = `${fmtHours(h)} ${fmtMins(m)}`;
    // if (s > 0) {
    //   durationText += ` ${fmtSeconds(s)}`;
    // }
  } else if (m > 0) {
    durationText = `${fmtMins(m)}`;
    // if (s > 0) {
    //   durationText += ` ${fmtSeconds(s)}`;
    // }
  } else {
    durationText = '0 mins';
    // durationText = `${fmtSeconds(s)}`;
  }

  return durationText;
};

export const enDistance = (distance, units = undefined) => {
  let distanceText;

  if (units === 'imperial' || (units === undefined && (country === 'US' || country === 'UK'))) {
    if (distance > 322) {
      distanceText = sprintf('%.1f miles', Math.floor(distance / 160.9) / 10);
    } else {
      distanceText = sprintf('%f miles', Math.floor(distance / 1609));
      distanceText = `${fmtFeet(Math.floor(3.28 * distance))}`;
    }
  } else {
    // const km = Math.floor(distance / 1000);
    const meters = distance % 1000;
    if (distance >= 100) {
      distanceText = sprintf('%.1f kilometers', distance / 1000);
    } else {
      // if (km > 0) {
      //   distanceText = `${fmtKilometers(km)}`;
      //   if (meters > 0) {
      //     distanceText += ` ${fmtMeters(meters)}`;
      //   }
      // } else {
      distanceText = `${fmtMeters(meters)}`;
      // }
    }
  }

  return distanceText;
};

export const enLeg = (duration, distance) => {
  const durationText = enTime(duration);
  const distanceText = enDistance(distance);
  return `${durationText}, ${distanceText}`;
};

export default { enLeg, enTime, enDistance };
